// src/components/blocks/Landing.jsx
import React, { useContext, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { DeckContext } from '../../context/DeckContext';
import BaseBlock from './BaseBlock';
import EdgeIndicator from './EdgeIndicator';
import { formatFeetInches } from '../../utils/measurementUtils';
import { LandingBlockProps } from '../../../../../../types/shared/props';
import EDGE_WIDTH from '../../../../../../constants/edgeWidth';

const Landing: React.FC<LandingBlockProps> = ({
	label,
	landing,
	onSelect,
	onUpdateBlock,
	setIsDragging,
}) => {
	const { state, dispatch } = useContext(DeckContext);
	const nodeRef = useRef(null);

	const { scaleFactor } = state;

	const landingWidth = landing.displayDimensions.width;
	const landingHeight = landing.displayDimensions.height;

	return (
		<BaseBlock
			block={landing}
			onSelect={onSelect}
			onUpdateBlock={onUpdateBlock}
			setIsDragging={setIsDragging}
			disabled={false}
			nodeRef={nodeRef}
		>
			<Box
				ref={nodeRef}
				style={{ transform: `rotate(${landing.rotation || 0}deg)` }}
				sx={{
					width: landingWidth * scaleFactor,
					height: landingHeight * scaleFactor,
					bgcolor: '#FFB200',
					cursor: 'pointer',
					position: 'absolute',
				}}
			>
				<Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
					{/* Edge Indicators */}
					{landing.edges.map((edge) => (
						<EdgeIndicator
							key={edge.label}
							position={edge.label.toLowerCase()}
							label={edge.label}
							type={edge.type}
							length={edge.length}
							onSelectEdge={(label) => {
								dispatch({
									type: 'SELECT_EDGE',
									payload: { blockId: landing.id, edgeLabel: label },
								});
							}}
							isSelected={
								state.selectedEdge?.blockId == landing.id &&
								state.selectedEdge?.edgeLabel === edge.label
							}
							parentIsSelected={state.selectedBlock?.id === landing.id}
						/>
					))}
					<Box
						sx={{
							width: '100%',
							display: 'flex',
							justifyContent: 'center',
							paddingTop: `${EDGE_WIDTH + 5}px`,
							cursor: 'pointer',
						}}
					>
						<Typography
							variant="caption"
							position="absolute"
							lineHeight={1.15}
							color="rgba(0, 0, 0, 0.6)"
							noWrap
							maxWidth={landingWidth}
							zIndex={10}
						>
							<p>
								<b>{label}</b>
							</p>
							{formatFeetInches(landing.dimensions.depth)}
							<span className="px-0.5">&times;</span>
							{formatFeetInches(landing.dimensions.width)}
						</Typography>
					</Box>
				</Box>
			</Box>
		</BaseBlock>
	);
};

export default Landing;
